import { Tag } from '../models/tag';
import axiosInstance, { getDefaultRequestConfig } from './base/axios.client';

export async function getTags() {
  return await axiosInstance.get<Tag[]>('/tags', getDefaultRequestConfig());
}
